import {
  CreateSubscriptionBundleInput,
  CreateSubscriptionBundleMutation,
  useCreateSubscriptionBundleMutation,
} from 'generated/graphql';
import { FetchResult } from '@apollo/client';

export type CreateBundleModel = {
  createBundle: (
    input: CreateSubscriptionBundleInput,
  ) => Promise<FetchResult<CreateSubscriptionBundleMutation>>;
};

export const useCreateBundleModel = (): CreateBundleModel => {
  const [createSubscriptionBundle] = useCreateSubscriptionBundleMutation();

  const createBundle = (input: CreateSubscriptionBundleInput) =>
    createSubscriptionBundle({
      variables: {
        input: input,
      },
    });

  return {
    createBundle,
  };
};
